/**
 * Effet Bouton Gourde — Dopper-style Burst Button
 *
 * Technique :
 * 1. On wrappe le texte du bouton dans .gourde-label
 * 2. On ajoute un .gourde-bubbles-wrap contenant un .gourde-fake-btn
 * 3. Au survol, des .gourde-bubble apparaissent et s'animent vers l'extérieur
 * 4. Le filtre SVG Gooey fusionne visuellement les bulles avec le fake-btn
 *    → Effet "eau qui se disperse" identique à Dopper
 */
(function () {
    'use strict';

    function initGourdeButtons() {
        var buttons = document.querySelectorAll('.btn-gourde');
        buttons.forEach(function (btn) {
            if (btn.dataset.gourdeInit) return;
            btn.dataset.gourdeInit = '1';

            // Sauvegarder le contenu texte original
            var originalContent = btn.innerHTML;

            // Construire la structure DOM
            var bubblesWrap = document.createElement('div');
            bubblesWrap.className = 'gourde-bubbles-wrap';

            var fakeBtn = document.createElement('div');
            fakeBtn.className = 'gourde-fake-btn';
            bubblesWrap.appendChild(fakeBtn);

            var label = document.createElement('div');
            label.className = 'gourde-label';
            label.innerHTML = '<span>' + btn.textContent.trim() + '</span>';

            btn.innerHTML = '';
            btn.appendChild(bubblesWrap);
            btn.appendChild(label);

            // Animation des bulles au survol
            var bubbles = [];
            var isHovering = false;
            var bubbleInterval = null;

            function createBubble(opacityFactor) {
                var opacityFactor = opacityFactor || 1;
                var bubble = document.createElement('div');
                bubble.className = 'gourde-bubble';

                var size = 8 + Math.random() * 16;
                bubble.style.width = size + 'px';
                bubble.style.height = size + 'px';

                // Position aléatoire autour du bouton
                var rect = label.getBoundingClientRect();
                var btnRect = btn.getBoundingClientRect();
                var centerX = rect.left - btnRect.left + rect.width / 2;
                var centerY = rect.top - btnRect.top + rect.height / 2;

                // Départ depuis les bords du bouton
                var angle = Math.random() * Math.PI * 2;
                var startRadius = Math.max(rect.width, rect.height) * 0.35;
                var startX = centerX + Math.cos(angle) * startRadius - size / 2;
                var startY = centerY + Math.sin(angle) * startRadius * 0.5 - size / 2;

                bubble.style.left = startX + 'px';
                bubble.style.top = startY + 'px';
                bubble.style.opacity = opacityFactor;
                bubble.style.transform = 'scale(1)';

                bubblesWrap.appendChild(bubble);
                bubbles.push(bubble);

                // Animation vers l'extérieur
                var endRadius = startRadius + 20 + Math.random() * 30;
                var endX = centerX + Math.cos(angle) * endRadius - size / 2;
                var endY = centerY + Math.sin(angle) * endRadius * 0.5 - size / 2;
                var duration = 400 + Math.random() * 300;

                var startTime = performance.now();

                function animate(now) {
                    var progress = Math.min((now - startTime) / duration, 1);
                    // Ease out cubic
                    var ease = 1 - Math.pow(1 - progress, 3);

                    var curX = startX + (endX - startX) * ease;
                    var curY = startY + (endY - startY) * ease;
                    var scale = 1 - progress * 0.5;
                    var opacity = (1 - progress) * opacityFactor;

                    bubble.style.left = curX + 'px';
                    bubble.style.top = curY + 'px';
                    bubble.style.transform = 'scale(' + scale + ')';
                    bubble.style.opacity = opacity;

                    if (progress < 1) {
                        requestAnimationFrame(animate);
                    } else {
                        if (bubble.parentNode) bubble.parentNode.removeChild(bubble);
                        var idx = bubbles.indexOf(bubble);
                        if (idx > -1) bubbles.splice(idx, 1);
                    }
                }

                requestAnimationFrame(animate);
            }

            var hoverStartTime = 0;
            var animationFrameId = null;

            function startAnimation() {
                hoverStartTime = performance.now();
                isHovering = true;
                
                function loop(now) {
                    if (!isHovering) return;
                    
                    var elapsed = now - hoverStartTime;
                    if (elapsed > 3000) {
                        isHovering = false;
                        return;
                    }

                    // Fréquence de création : on crée une bulle tous les ~120ms
                    // On ajoute un effet de fondu sur la fin (entre 2s et 3s)
                    var factor = 1;
                    if (elapsed > 2000) {
                        factor = 1 - (elapsed - 2000) / 1000;
                    }

                    // Utilisation d'un compteur pour simuler l'intervalle dans le RAF
                    if (Math.random() < 0.15 * factor) {
                        createBubble(factor);
                    }

                    animationFrameId = requestAnimationFrame(loop);
                }
                animationFrameId = requestAnimationFrame(loop);
            }

            btn.addEventListener('mouseenter', function () {
                if (isHovering) return;
                startAnimation();
            });

            btn.addEventListener('mouseleave', function () {
                isHovering = false;
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                    animationFrameId = null;
                }
            });
        });
    }

    // Init au chargement
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGourdeButtons);
    } else {
        initGourdeButtons();
    }

    // Re-init pour Shopify sections (éditeur de thème)
    document.addEventListener('shopify:section:load', initGourdeButtons);

})();
